/**
 * Google Tag Manager — client component.
 *
 * Renders the GTM container script **only** when a valid
 * `NEXT_PUBLIC_GTM_ID` is provided (i.e. production builds).
 *
 * Uses `next/script` with `afterInteractive` strategy so it never
 * blocks the critical rendering path.
 */
'use client';

import Script from 'next/script';
import { Capacitor } from '@capacitor/core';

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

export function GoogleTagManager() {
  if (!GTM_ID) return null;

  // 'web' | 'ios' | 'android' — pushed to dataLayer before GTM so container
  // tags/triggers/variables can read {{platform}}.
  const platform = Capacitor.getPlatform();

  return (
    <Script id="gtm-script" strategy="lazyOnload">
      {`window.dataLayer=window.dataLayer||[];window.dataLayer.push({platform:'${platform}'});` +
      `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${GTM_ID}');`}
    </Script>
  );
}

export function GoogleTagManagerNoscript() {
  if (!GTM_ID) return null;

  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
      />
    </noscript>
  );
}
